/* Extracted from sections/main-product.liquid on 2026-08-15.
   Was inline in every document that renders this file; now fetched once and
   cached. Deferred, so it runs after the DOM is parsed rather than at its old
   position — safer for the DOM queries inside, not riskier.
   No Liquid in here, which is why it could move at all. */

/* Gallery Scroll Reveal — fade in media items as they enter viewport */
  (function () {
    if (window.innerWidth < 900) return;
    var items = document.querySelectorAll('.main-product__media-item:not(.main-product__media-item--hero)');
    if (!items.length) return;

    var io = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add('mp-visible');
            io.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.15, rootMargin: '0px 0px -40px 0px' }
    );

    items.forEach(function (item, i) {
      item.style.transitionDelay = (i % 2 === 1 ? '0.1s' : '0s');
      io.observe(item);
    });
  })();
